import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import {Col, Input, Row, CardBody, Tooltip, InputGroupAddon, InputGroupText} from "reactstrap";
import {injectIntl} from "react-intl";
import InputMask from "react-input-mask";
import InputGroup from "reactstrap/es/InputGroup";
import {getCurrentMicroTime} from "../../../../../reducers/timeMeasuring/actions";
import {debounce, throttle} from "lodash";
import {useCallback, forwardRef, useImperativeHandle} from "react";
import AnswerContainer from "../answerContainer";

export const NumericInput = forwardRef((props, ref) => {
	const {question, isError, changeValue, value, classes, forceMinValue, answer, details, detail} = props

	const numberValue = Number(value);

	const getMaxValue = () => {
		if (answer) {
			let max = Number.MAX_VALUE;
			let sum = 0;

			if (question.summaryMax) {
				details.map((det) => {
					sum = sum + det.value1
				})

				let sumNoDetail = detail ? (sum - detail.value1) : 0;
				if (sum >= question.summaryMax && detail) {
					return question.summaryMax - sumNoDetail
				}
			}

			if (question.valueMax) {
				max = Number(question.valueMax)
			}

			if (answer.maxValue) {
				max = Number(answer.maxValue)
			}

			return max;
		}

		return Number(question.valueMax) ? Number(question.valueMax) : Number.MAX_VALUE;
	}

	const getMinValue = () => {
		if (answer) {
			let min = 0;

			if (question.valueMin) {
				min = Number(question.valueMin)
			}

			if (answer.minValue) {
				min = Number(answer.minValue)
			}

			return min;
		}

		return Number(question.valueMin) ? Number(question.valueMin) : 0;
	}

	const valueMax = getMaxValue();
	const valueMin = getMinValue();
	const step = question.step ? question.step : 1;
	const [touched, setTouched] = React.useState(numberValue > valueMin && numberValue < valueMax ? true : false);
	const [initialValue, setInitialValue] = React.useState(value);
	const [inputValue, setInputValue] = React.useState(value)

	useImperativeHandle(ref, () => ({
		setInputValueForce(value) {
			if (question.decimals) {
				value = value.toFixed(question.decimals);
			}
			setInputValue(value);
		}
	}));

	React.useEffect(() => {
		if (Number(forceMinValue) && forceMinValue > inputValue) {
			setInputValue(forceMinValue);
		}
	}, [forceMinValue])

	const isValid = () => {
		if (Number(value) >= valueMin
			&& Number(value) <= valueMax) {
			return !isError && value && isTouched();
		}

		return false;
	}

	const isTouched = () => {
		return touched || initialValue !== value;
	}

	const onChange = (targetValue) => {
		let value = targetValue;
		if (forceMinValue && forceMinValue > value) {
			value = forceMinValue;
		}

		if (value < valueMin) {
			value = valueMin;
		}

		if (value > valueMax) {
			value = valueMax;
		}

		if (value === '' || /^\d*\.?\d*$/.test(value)) {
			value = value.toFixed(question.decimals);
			setTouched(true)
			changeValue(value);
		}

		setInputValue(value);
	}


	const debouncedOnChange = useCallback(debounce(onChange, 750, []), [initialValue]);

	const changeValueEvent = (e) => {
		let targetValue = e.target.value.replace(',', '.');
		targetValue = targetValue.replaceAll(/[a-zA-Z]/g,"");
		targetValue = targetValue.replaceAll(" ", '')
		setInputValue(targetValue)

		if (forceMinValue > Number(targetValue)) {
			targetValue = forceMinValue
		}

		if (question.decimals || (question.valueMax && question.valueMin)) {
			debouncedOnChange(Number(targetValue))
		} else {
			onChange(Number(targetValue))
		}
	}

	return (
		<React.Fragment>
			<InputGroup className={"numeric-input " + classes}>
				<InputGroupAddon addonType={"prepend"} onClick={() => onChange(Number(Number(value) - Number(step)))} className={
					classnames({
						'pointer': true,
						'disabled': Number(Number(value) - Number(question.step)) < valueMin
					})
				}>
					<i className="fas fa-chevron-down" />
				</InputGroupAddon>
				<InputMask
					inputmode={"numeric"}
					type="text"
					className={
						classnames({
							'text-center': true,
							'valid': isValid(),
							'error': isError
						})
					}
					min={valueMin}
					max={valueMax}
					step={question.step}
					onFocus={e => {
						e.target.select();
					}}
					onBlur={() => {
						if (value) {
							setTouched(true)
						}
					}}
					onChange={changeValueEvent}
					value={inputValue}
				/>
				<InputGroupAddon addonType={"append"} onClick={() => {
					onChange(Number(Number(value) + Number(step)))
				}}
					className={
						classnames({
							'pointer': true,
							'disabled': Number(Number(value) + Number(question.step)) > valueMax
						})
					}>
					<i className="fas fa-chevron-up" />
				</InputGroupAddon>
				{question.valueText && <InputGroupAddon className={"d-none d-md-flex ml-3 p-2 color-default"} addonType={"append"} onClick={() => onChange(Number(Number(value) + Number(question.step)))}>
					<span>{question.valueText}</span>
				</InputGroupAddon>}
			</InputGroup>
			{question.valueText && <AnswerContainer
				classes={"text-center pointer-none font-weight-bold p-0 d-block d-md-none suffix"}
				checked={false}
				component={
					<div className={"d-flex align-items-center h-100 text-center"}>
						<span className={"w-100"}>{question.valueText}</span>
					</div>
				}
			/>}
		</React.Fragment>
	);
})